import { type FC } from 'react';

import { InitPageRenderer } from './init-page.renderer';

export const InitPageContainer: FC = () => <InitPageRenderer />;
